function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M24404.363 18979.965a1.246 1.246 0 0 1 .887-2.125 1.176 1.176 0 0 1 .873.352 1.226 1.226 0 0 1 .377.895 1.251 1.251 0 0 1-2.137.879zm-5 0a1.246 1.246 0 0 1 .885-2.125 1.184 1.184 0 0 1 .875.352 1.241 1.241 0 0 1 .377.895 1.251 1.251 0 0 1-2.137.879zm5-5.42a1.245 1.245 0 0 1 .887-2.125 1.176 1.176 0 0 1 .873.352 1.228 1.228 0 0 1 .377.893 1.253 1.253 0 0 1-2.137.881zm-5 0a1.247 1.247 0 0 1 0-1.76 1.259 1.259 0 0 1 1.76-.014 1.244 1.244 0 0 1 .377.893 1.253 1.253 0 0 1-2.137.881zm5-5.42a1.248 1.248 0 0 1 .887-2.127 1.17 1.17 0 0 1 .873.354 1.227 1.227 0 0 1 .377.891 1.251 1.251 0 0 1-2.137.883zm-5 0a1.245 1.245 0 0 1 0-1.758 1.194 1.194 0 0 1 .885-.369 1.178 1.178 0 0 1 .875.354 1.242 1.242 0 0 1 .377.891 1.251 1.251 0 0 1-2.137.883z",
  transform: "translate(-24392.891 -18963.664)"
});

function SvgIconDragIconOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragIconOrange);
export default __webpack_public_path__ + "static/media/icon_drag-icon-orange.63a0cf84.svg";
export { ForwardRef as ReactComponent };